export default __webpack_public_path__ + "static/media/jeep.cd2a19b6.svg";